import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ContentPublishError extends CodedError {
  static get errorName() {
    return errorCodes.contentMissingTitleError.code;
  }

  constructor(message: string = errorCodes.contentMissingTitleError.message) {
    super(message);
    this.code = errorCodes.contentMissingTitleError.code;
    this.message = `${message} ${errorCodes.contentMissingTitleError.code}`;
    this.name = errorCodes.contentMissingTitleError.name;
  }
}
